var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{class:_vm.classTitle,domProps:{"textContent":_vm._s('#' + _vm.issue.number)},on:{"click":_vm.openIssue}})}
var staticRenderFns = []

export { render, staticRenderFns }